import { HttpClient, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, forkJoin, map, Observable, of, Subject } from 'rxjs';
import { Global } from '../global/globalApi';
import { COMPONENT_NAME, LAYOUT_ID, AuthMenu } from '../models/Constants';
import { GEN_attributes, personData, sAuthModel } from '../models/customer.model';
import { NewAgentApiService } from './new-agent-api.service';
import { RootScopeService } from './root-scope.service';
import * as Constants from './../models/Constants';
import { InteractionHistoryService } from './interaction-history.service';
import { accountDtModal } from '../models/CustomerAccountSearch';
import * as _ from 'lodash'; // Import lodash library
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Tab } from '../models/tab.model';
import { AutoLaunchALSService } from './auto-launch-als.service';
import { AccountFreezeService } from './account-freeze.service';
import { LogService } from './log.service';
import { AaaSService } from './aaas.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerAccountBusinessLogicService {
  public customerAccountDt: accountDtModal[] = [];
  public activeTabDt: any = null;
  public domainData: any = null;
  public selectedIndex: string = '';
  public domainErrMsg: string = 'NA';
  /**Used for handling loader of 3 api hit at first load of CA tab */
  firstLoadLoader: boolean = false;
  leftNavLoader: boolean = false;
  clientInfoLoader: boolean = false;
  /*Used for displaying  loader at domain card **/
  domainLoader: boolean = false;

  loaderTimeoutId: any;
  showLoaderMsg: boolean = false;
  public allIHListData: any = null; // allIHListData is use to hold all IH records
  authenticateClass: string = '';
  public indicativeDataForm!: FormGroup; 
  refreshFlag: boolean = false;
  fileName: string = "customer-account-business-logic-service";

  constructor(
    public apiService: NewAgentApiService,
    private http: HttpClient,
    public rootScopeService: RootScopeService,
    private initHistService: InteractionHistoryService,
    public fb: FormBuilder,
    public autoLaunchConfigService: AutoLaunchALSService,
    public accountFreezeService : AccountFreezeService,
    public logger:LogService,
    public aaasService:AaaSService,
  ) {
    if (this.rootScopeService.customerAccountDt?.length > 0) {
      this.customerAccountDt = this.rootScopeService.customerAccountDt;
      this.rootScopeService.customerAccountDt = [];
    }
  }



  //getSSOLink return SSO Link of Case Management
  getSSOLink(uri: string): Observable<any> {
    let model = {
      clientId: this.rootScopeService.activeCustTab?.clientId,
      linkId: 'ACCOUNT-HRX-ASSIST',
      customerSessionId: this.rootScopeService.activeCustTab?.customerSessionId,
    };

    return this.http.post(
      `${Global.domainUrl}awcp${'/api/link/getLinkUrl'}`,
      model,
      {
        headers: this.rootScopeService.getCommonHeaders(Constants.apiVersions),
        responseType: 'text',
      }
    );
  }

  startTimerForLoader() {
    let that = this;
    this.loaderTimeoutId = setTimeout(() => {
      /* istanbul ignore next */
      that.showLoaderMsg = true;
    }, 1 * this.rootScopeService.showLoaderMsgThreshold * 1000);
  }

  callRepeatAlertApi(tab) {
   this.logger.infoLogs("Repeat Alert API called for customerSessionId: "+tab.customerSessionId, this.fileName);
    return this.http.get(Global.domainUrl + Global.GET_REPEAT_ALERT, {
      headers: this.rootScopeService.getCommonHeaders(Constants.apiVersions).append('awcpcusttoken', tab.customerSessionId),
      params: {
        contactId: tab.id,
        clientId: tab.clientId,
        view: "CarePortal"
      },
    });
  }

  getRepeatAlertStatus(tab) {
    this.callRepeatAlertApi(tab).subscribe({
      next: (res: any) => {
       
        if (res?.data && res?.data?.interval && res?.data?.['interval']?.length > 0) {
          this.logger.debugLogs("Repeat Alert API Response: "+JSON.stringify(res), this.fileName);
          let msg = res.data?.['interval'][0].repeatContactAlert;
          if (msg != 'NA') {
            this.rootScopeService.activeCustTab.repeatAlertMsg = res.data?.['interval'][0].repeatContactAlert;
            this.rootScopeService.activeCustTab.repeatCallerCode = res.data?.['interval']?.[0]?.repeatCallerCode;
            this.rootScopeService.activeCustTab.showRepeatAlert = true;
            this.rootScopeService.activeCustTab.showRepeatAlertBriefView = true;
            this.rootScopeService.activeCustTab.showRepeatAlertListView = true;
          } else {
            this.rootScopeService.activeCustTab.showRepeatAlert = false;
            this.rootScopeService.activeCustTab.showRepeatAlertBriefView = false;
            this.rootScopeService.activeCustTab.showRepeatAlertListView = false;
          }
        }
        else {
          this.rootScopeService.activeCustTab.showRepeatAlert = false;
          this.rootScopeService.activeCustTab.showRepeatAlertBriefView = false;
          this.rootScopeService.activeCustTab.showRepeatAlertListView = false;
        }
      },
      error: (error) => {
       this.logger.errorLogs("Error in Repeat Alert API: "+JSON.stringify(error), this.fileName);
        this.rootScopeService.activeCustTab.showRepeatAlert = false;
        this.rootScopeService.activeCustTab.showRepeatAlertBriefView = false;
        this.rootScopeService.activeCustTab.showRepeatAlertListView = false;
      },
    });

  }


  getClientInfoCardDataApiData(clientId) {
    this.logger.infoLogs("getClientInfoCardDataApiData called for clientId: "+clientId, this.fileName);
    let url = Global.domainUrl + 'awcp/client/' + clientId + "/properties"
    return this.http.get(url, {
      headers: this.rootScopeService.getCommonHeaders(Constants.apiVersions),
    });
  }
  /**
   * 
   * @param clientId @author :Pooja
   * @param forRefreshAction 
   * @param self 
   * Story -CCR1-5595
   */

  getClientInfoCardData(clientId, forRefreshAction, self?) {
  
    if (!forRefreshAction && this.rootScopeService.clientPropDataMap.get(clientId)?.length > 0 ) {
      if (self){
        /* istanbul ignore next */
        self.clientId = clientId;
      }

      this.rootScopeService.activeCustTab.clientInfoCardData = this.rootScopeService.clientInfoCard.clientInfoVSClientIdMap[clientId];
      this.rootScopeService.mulLanData = this.rootScopeService.clientPropDataMap.get(clientId);
      this.logger.infoLogs("Client Info Card Data from cache", this.fileName);

      this.getAccountFreezeData();
      this.defaultServiceOnLoad();
    }
    else {
      this.clientInfoLoader = true;
      this.getClientInfoCardDataApiData(clientId).subscribe({
        next: (data: any) => {
          /* istanbul ignore next */
          if (data['data'] && data['data'] != null) {
            this.logger.debugLogs("Client Info Card API Response: "+JSON.stringify(data), this.fileName);
            this.rootScopeService.mulLanData = data['data'];
            if(data?.['data']?.find(x=>x.propertyName=="PIN-RESET")){
              this.rootScopeService.deliveryMethodsMap.set(clientId,data?.['data']?.find(x=>x.propertyName=="PIN-RESET")?.propertyValue);
            }
            this.rootScopeService.clientPropDataMap.set(clientId,data['data']);
            let mainData = data['data'];
            let that = this;

            try {
              let newData: any[] = [];
              let attributeConfigArr: any[] = [];
              for (let i = 0; i < mainData?.length; i++) {
                let each = mainData[i];
                try {
                  each['parsedObjectData'] = JSON.parse(each?.propertyValue)
                }
                catch (err) {
                  /**Its for handling a scenario wherein parsing fails for each service card CCR1-6321 /Issue 1 */
                  each['parsingError'] = true;
                  each['apiFailed'] = true;
                }

                if (each['propertyName']?.startsWith(Constants.ATTRIBUTE_PROPERTY_NAME_CLIENT_INFO)) {
                  newData.push(each);
                }
                else {
                  attributeConfigArr.push(each);
                }
              }

              /**
              * Sorting alphabetically on basis of field "Service"
              */
              newData?.sort(function (a, b) {
                var textA = a?.parsedObjectData?.['Service']?.toUpperCase();
                var textB = b?.parsedObjectData?.['Service']?.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
              });
              if (self)
                self.clientId = clientId;

              this.rootScopeService.clientInfoCard.clientInfoVSClientIdMap[clientId] = newData;
              this.rootScopeService.attributeClientConfigMap[clientId] = attributeConfigArr;
              this.defaultServiceOnLoad();
              this.getAccountFreezeData();
             
            }
            catch (error) {
              this.logger.errorLogs("Error in parsing Client Info Card Data: "+JSON.stringify(error), this.fileName);
              this.rootScopeService.clientInfoCard.clientInfoVSClientIdMap[clientId] = [];
            }


          }
          else {
            /**Condition whendata is not available for this clientId */
            if (self)
              self.clientId = clientId;

            this.rootScopeService.clientInfoCard.clientInfoVSClientIdMap[clientId] = [];

          }

          this.clientInfoLoader = false;
        },
        error: (error) => {
          /* istanbul ignore next */
          let obj = { 'apiFailed': true, 'parsingError': false };
          let arr: any[] = [];
          /* istanbul ignore next */
          arr.push(obj)
            /* istanbul ignore next */
          this.rootScopeService.clientInfoCard.clientInfoVSClientIdMap[clientId] = arr;
            /* istanbul ignore next */  
          this.clientInfoLoader = false;
        }
      })
    }
  }

  /**CCR1-8142 */
  getAccountFreezeData(){
    /** Below piece of code to be executed for only customer acccount */
    if(this.rootScopeService.activeCustTab.id != 0 && this.rootScopeService.activeCustTab.id != 1 && (this.rootScopeService.customerLink == this.rootScopeService.activeCustTab.customerSessionId)){
      /* istanbul ignore next */
     // this.getAaasEnabledClient(this.rootScopeService.activeCustTab);//CCR3-14085
      this.accountFreezeService.getAccountFreezeStatusFromServer();
      this.getAuthMethods(this.rootScopeService.activeCustTab);
    }
  }
  
  // Triggering All API call for Customer account cards
  /* istanbul ignore next */
  /**
   * Opens a new customer account tab and initializes related data and UI components.
   *
   * This method performs the following actions:
   * - Logs the invocation with the customer session ID.
   * - Clears retained customer account data if `updateTabIndex` is not provided.
   * - Checks for live call or live chat scenarios and triggers repeat alert status if necessary.
   * - Prepares and sends multiple API requests in parallel to fetch navigation, todo list, and role type list data.
   * - Updates the active tab data and customer account data array with the fetched results.
   * - Handles simulation mode by invoking simulation-specific API methods.
   * - Manages loader state and progress indicators.
   * - Fetches additional client information and service data.
   * - Updates external tab list and checks agent status for active calls if applicable.
   * - Handles errors gracefully and logs them.
   *
   * @param tab - The tab object containing customer session and account details.
   * @param updateTabIndex - (Optional) The index of the tab to update in the customer account data array.
   */
  openNewCustAcc(tab, updateTabIndex?) {
    this.logger.infoLogs("openNewCustAcc called for customerSessionId: "+tab.customerSessionId, this.fileName);
    try {
      if (updateTabIndex == undefined) {
        this.initHistService.clearRetainedDataOfCA();       
      }
      if (this.rootScopeService.isLiveCall) {
        if (!tab.additionalAccount) {
          //   if(this.rootScopeService.isCallBackCall || this.rootScopeService.callType != Constants.OUTBOUND_CALL_TYPE){
          this.getRepeatAlertStatus(tab);
          // }
        }
      }


      if (this.rootScopeService.isLiveChat && !tab?.additionalAccount)
        this.getRepeatAlertStatus(tab);

      let type, data;

      type = {
        component: 'CLIENT-INFORMATION',
        id: tab.customerSessionId,
        domain: 'COMMON',
      };
      data = this.setPersonDetails(tab, type);
      const clientInfo = this.apiService
        .postApi(Global.openAccountApi.getPersonData, data, 'false', Constants.apiVersions, false)
        .pipe(catchError((err) => of({ isError: true, error: err })));

      data = {
        componentName: 'CUSTOMER-NAVIGATION',
        clientId: tab.clientId,
        domain: 'COMMON',
        layoutId: 'ACCOUNT-LEFT-NAV',
        securityLevel: this.updateScurityLevel(tab?.CS_SECURITY_LEVEL),
        roleType: tab?.defaultRole,
        customerSessionId: tab?.customerSessionId,
        customerType: tab?.customerType,
      };
      //data = this.setPersonDetails(tab, type);
      const navBar = this.apiService //this.http.get<any>('./../../assets/JSON/Navigation.json');
        .postApi(
          Global.openAccountApi.customerNavigation,
          data,
          'false',
          Constants.apiVersions,
          false
        )
        .pipe(catchError((err) => of({ isError: true, error: err })));
      type = {
        component: 'CUSTOMER-OVERVIEW',
        id: tab.customerSessionId,
        domain: 'COMMON',
      };
      data = this.setPersonDetails(tab, type);
      const aboutTheCust =
        // this.http.get<any>(
        //   './../../assets/JSON/aboutThecustomer.json'
        // );
        this.apiService
          .postApi(
            Global.openAccountApi.getPersonData,
            data,
            'false',
            Constants.apiVersions,
            false
          )
          .pipe(catchError((err) => of({ isError: true, error: err })));

      let body = {
        clientId: tab.clientId,
        layoutId: LAYOUT_ID.CustomerAccountMyTodo,
        customerSessionId: tab?.customerSessionId,
        roleType: tab?.defaultRole,
        securityLevel: this.updateScurityLevel(tab?.CS_SECURITY_LEVEL),
        customerType: tab?.customerType,
      };
      const myTodo = this.apiService //this.http.get<any>('./../../assets/JSON/Navigation.json');
        .postApi(
          Global.dashboardApi.dashboardLeftNavigation,
          body,
          'false',
          Constants.apiVersions,
          false
        )
        .pipe(catchError((err) => of({ isError: true, error: err })));

      let roleTypeBody = {
        clientId: tab.clientId,
        customerSessionId: tab.customerSessionId,
      };
      const roleTypeList = this.apiService.postApi(
        Global.openAccountApi.getRoleTypeList,
        roleTypeBody,
        'false',
        Constants.apiVersions,
        false
      ).pipe(catchError((err) => of({ isError: true, error: err })));

      this.firstLoadLoader = true;
      this.startTimerForLoader();
      forkJoin([
        //clientInfo,
        navBar,
        //aboutTheCust,
        myTodo,
        roleTypeList,
      ]).subscribe((res) => {
        console.log('res', res);
        if (res) {
          let msg = Constants.CARD_DATA_FAILURE_MSG;
          //Verfying about card details 
          // if (
          //   res[2] &&
          //   res[2]?.data &&
          //   res[2]?.data?.topics &&
          //   res[2]?.data?.topics.length > 0 &&
          //   res[2]?.data?.topics[0]?.groups
          // ) {
          //   msg = 'NA';
          // }

          // if(res[0] && res[0]?.data && res[0]?.data?.topics && res[0]?.data?.topics?.length > 0 && res[0]?.data?.topics[0]?.groups){
          //   clientInfoData = 
          // }
          //let clientInfoArr = [];
          // if (res[0]?.data?.topics && res[0]?.data?.topics.length > 0) {
          //   clientInfoArr = res[0]?.data?.topics[0]?.groups;
          // }


          this.activeTabDt = {
            id: tab.customerSessionId,
            navBar: res[0]?.data,
            myTodo: res[1]?.data?.menuList,
            domainName: res[0]?.data?.menuList[0]?.heading,
            navBarErrMsg: this.checkPresenceOfErrorGroupField(
              res[0]?.data,
              Constants.LEFT_NAV_CARD_FAILURE_MSG
            ),
            aboutTheCustomerErrMsg: msg,
            myTodoErrMsg: res[1]?.data?.menuList
              ? res[1]?.data?.menuList.length > 0
                ? 'NA'
                : 'NoData'
              : Constants.CASE_MNGMT_API_FAIL_MSG,
            roleTypeList: res[2]?.data?.participantIdMappingInfoList ? res[2]?.data?.participantIdMappingInfoList : [],
          };
          if (updateTabIndex != undefined && this.customerAccountDt?.[updateTabIndex]) {
            this.customerAccountDt[updateTabIndex] = this.activeTabDt;
          }
          else this.customerAccountDt.push(this.activeTabDt);

        }
      ///Handles simulation mode by invoking simulation-specific API methods. CCR3-12424
        if(this.rootScopeService.simulationData?.isSimulationModeActive){
        this.apiService.getLOBMethodsForSimulation(tab.clientId);
         this.rootScopeService.simulationRecords.forEach((x: any) => {
           if(x.conversationId == tab.conversationId && x.fullName.includes("Unknown -")) {
             x.fullName = tab.title;
           }
         });
        }

        /**Stopping progress indicator on api response and killing the timer
         * addeded as a prt of story CCR1-2502 ***/
        clearTimeout(this.loaderTimeoutId);
        this.firstLoadLoader = false;
        this.showLoaderMsg = false;
        this.logger.debugLogs("Account opening API called response for customerSessionId: "+tab.customerSessionId +""+JSON.stringify(res), this.fileName);
      });

      // this.getTransId(tab);
    
      //this.getAuthMethods(tab);
      // this.getAutoLaunchConfigurationData(tab);
      this.getClientInfoCardData(tab.clientId, false);
      this.getClientInfoCardDefaultService(tab?.clientId);
      this.rootScopeService.externalTabList.set(tab?.customerSessionId,[]);     
      if (this.rootScopeService.isLiveCall && updateTabIndex == undefined) {
         // setTimeout(() => {
             this.checkAgentForActiveCall(this.rootScopeService.activeCustTab);
         // }, 6000);         
        }
       
    }
    catch (error) {
      this.logger.errorLogs("Error in openNewCustAcc: "+JSON.stringify(error), this.fileName);
    }
  }

  getAutoLaunchDataFromApi(tab) {
    let url = Global.domainUrl + Global.customerApi.autoLaunchAPI;
    this.logger.infoLogs("getAutoLaunchDataFromApi called for customerSessionId: "+tab.customerSessionId+"API Url : "+url, this.fileName);
    return this.http.get(url, {
      headers: this.rootScopeService.getCustAccHeaders(Constants.apiVersions, this.rootScopeService.activeCustTab.customerSessionId),
      params: {
        clientId: this.rootScopeService.activeCustTab.clientId,
      }
    });

  }

  /**
   * CCR1-4618 
   * Below method hit the api at launch of CA 
   * to get List of Urls to launch.
   * configured for the client.
   * @author-Pooja
   */

  getAutoLaunchConfigurationData(tab) {
    // tab.clientType =  Constants.ALS_Config_DesktopIndicator;

    /** */
    //  tab.activeCall = true;
    //  tab.activeChat = true;
    //  tab.personId = '6140384';
    //  tab.externalLeaveId = '23092600039';
    // tab.personId = tab.employeeId;

    let param = { 'clientId': tab?.clientId }
   
    this.getAutoLaunchDataFromApi(tab).subscribe({
      next: (res) => {
      
        if (res['data'] && res['data'].length > 0) {
          this.autoLaunchConfigService.openALSTAb(tab, res['data']);
          this.logger.debugLogs("Auto Launch Configuration API Response: "+JSON.stringify(res), this.fileName);
        }
        else {
          this.logger.infoLogs("client is not of ALS type",this.fileName)
        }

      },
      error: (error) => {
        this.logger.errorLogs("Error in getAutoLaunchConfigurationData: "+JSON.stringify(error), this.fileName);
        this.rootScopeService.enableAlerts(
          Constants.ERROR, 'There is some error in getting auto launch configuration data');
      },
    });
  }



  //    //CCR3-3213
  // KCWindowInLiveInteraction(tab, restore, Url) {
  //   /* istanbul ignore next */
  //   if (!tab.additionalAccount && Url && (!restore || (restore && (tab.activeChat || tab.activeCall)))) this.rootScopeService.openKCWindow(tab, Url
  //     .replaceAll('#USR.clientId', tab.clientId));//tab.clientId?.includes('P0095') ? '00095' :
  //   else if (!Url) this.rootScopeService.enableAlerts(Constants.ERROR, Constants.AlertMsg.error500);
  //   }

  // getTransId(tab) {
  //   if (
  //     !this.rootScopeService.clientSystemIds.find(
  //       (x) => x?.clientId == tab.clientId
  //     )
  //   ) {
  //     this.apiService
  //       .getApi(
  //         Global.customerApi.getClientSystemMapping + '/' + tab.clientId,
  //         null,
  //         'false',
  //         false
  //       )
  //       .subscribe({
  //         next: (res) => {
  //           this.rootScopeService.clientSystemIds.push({
  //             clientId: tab.clientId,
  //             data: res.data,
  //           });
  //         },
  //         error: (error) => {
  //           console.error('There was an error!', error);
  //         },
  //       });
  //   }
  // }
  
  /* istanbul ignore next */
  /**
   * Retrieves authentication methods for a given tab and updates the authMethodConfig in rootScopeService.
   * If the clientId of the tab is not already present in authMethodConfig, it makes an API call to fetch the authentication content list.
   *
   * @param {Tab} tab - The tab object containing clientId.
   * @returns {void}
   */
  getAuthMethods(tab: Tab) {
    try {
      
    
   
    if (tab?.clientId && !this.rootScopeService.authMethodConfig.has(tab.clientId))
      this.apiService.getApi(Global.authenticationApis.gethenticationContentList, { clientId: tab?.clientId }, 'false', false).subscribe({
        next: (res) => {
          if (res?.data?.length > 0) {

            res.data.forEach((element, index) => {
              // If platformSupport is present, parse it as JSON
              if (element?.platformSupport) {
                try {
                  res.data[index].platformSupport = JSON.parse(element?.platformSupport);

                } catch (error) {
                  res.data[index].platformSupport = {};
                  this.logger.errorLogs("Error in parsing platformSupport: " + JSON.stringify(error), this.fileName);
                }

              }
            });
            setTimeout(() => {
              if (!tab.IS_AAAS_ENABLED)
                this.rootScopeService.authMethodConfig.set(tab?.clientId, res.data);
            }, 10);

          }
        },
        error: (error) => {
         this.logger.errorLogs("Error in getAuthMethods: "+JSON.stringify(error), this.fileName);
        },

      });
    } catch (error) {
     this.logger.errorLogs("Error in getAuthMethods: "+JSON.stringify(error), this.fileName);
    }

  }
  updateScurityLevel(CS_SECURITY_LEVEL) {
    if (CS_SECURITY_LEVEL == '1') return '2';
    else return CS_SECURITY_LEVEL;
  }

  /**
   * Method to call single API  request
   * @author :Amarjeet
   */
  getLatestCustomerAccDT(model, index) {
    this.leftNavLoader = true;
    this.startTimerForLoader();
    let data = {
      componentName: model.componentName, //'CUSTOMER-NAVIGATION',
      clientId: this.rootScopeService.activeCustTab.clientId,
      domain: 'COMMON',
      layoutId: 'ACCOUNT-LEFT-NAV',
      securityLevel: this.updateScurityLevel(
        this.rootScopeService?.activeCustTab?.CS_SECURITY_LEVEL
      ),
      roleType: this.rootScopeService.activeCustTab.defaultRole,
      customerSessionId: this.rootScopeService.activeCustTab.customerSessionId,
      customerType: this.rootScopeService.activeCustTab.customerType,
    };
    //data = this.setPersonDetails(tab, type);
    this.logger.debugLogs("getLatestCustomerAccDT API Request: "+JSON.stringify(data), this.fileName);
    const navBar = this.apiService
      .postApi(model.url, data, 'false', Constants.apiVersions, false)
      .subscribe({
        next: (res) => {
           /* istanbul ignore next */
          if (res) {
            clearTimeout(this.loaderTimeoutId);
            this.leftNavLoader = false;
            this.showLoaderMsg = false;
            // storing updated data into cache
            this.customerAccountDt[index][model.type] = res?.data;
            let domains = res?.data?.menuList
              ?.find((xx) => xx.id == 'CARE-PORTAL-CUSTOMER')
              ?.subMenuList?.find((xxx) => xxx.id == 'CUSTOMER-INFORMATION')
              ?.subMenuList.map((x) => x.domain);
            // removing cached domain data if user change roleType
            domains.forEach((element) => {
              if (this.customerAccountDt[index][element]) {
                this.customerAccountDt[index][element] = null;
              }
            });

            this.activeTabDt[model.type] = res?.data;
          }
          /* istanbul ignore next */
          this.logger.debugLogs("getLatestCustomerAccDT API Response: "+JSON.stringify(res), this.fileName);
        },
        error: (error) => {
          clearTimeout(this.loaderTimeoutId);
          this.leftNavLoader = false;
          this.showLoaderMsg = false;
          this.logger.errorLogs("Error in getLatestCustomerAccDT: "+JSON.stringify(error), this.fileName);
        },
      });
  }

  /**
   * @param activeTabDt Below method is used for
   * checking response of getPersonData api has errorGroup field in
   * it or not  which signifies even if api returns 200 ok
   * there is api failure .
   * Created as a part of CCR1-1961
   * @author  : Pooja Gupta
   */
  checkPresenceOfErrorGroupField(clientInfoGroupArr, msg) {
    let errMsg = 'NA';
    if (clientInfoGroupArr) {
      for (let i = 0; i < clientInfoGroupArr.length; i++) {
        let clientInfoGroupObj = clientInfoGroupArr[i];
        if (clientInfoGroupObj) {
          /**Case when api is sucessful i.e 200 ok response but UDP hit failed */
          if (clientInfoGroupObj.hasOwnProperty(Constants.ERRORGROUP_FIELD)) {
            if (
              clientInfoGroupObj[Constants.ERRORGROUP_FIELD] ==
              Constants.DATA_NOT_AVAIL_BACKEND
            ) {
              errMsg = Constants.DATA_NOT_AVAIL_UI;
            } else {
              errMsg = msg;
            }
            break;
          }
        } else errMsg = msg;
      }
    } else {
      /***Case when api is itself failed and throws 400 or 500 response */
      errMsg = msg;
    }

    return errMsg;
  }

  setPersonDetails(tab, type) {
    let personalData = new personData();
    personalData.clientId = tab.clientId;
    personalData.globalIdentifierId = tab.id;
    personalData.userSessionId = this.rootScopeService.sessionId;
    personalData.customerSessionId = type.id;
    personalData.serviceName = 'get-person-data';
    personalData.urlPattern = 'string';
    personalData.apiVersion = Constants.apiVersions;
    personalData.componentName = type ? type.component : 'PERSON-PID-DATA';
    personalData.openAccountProcess = false;
    personalData.domain = type.domain;
    personalData.roleType = tab?.defaultRole;
    personalData.planTypeList = type?.planTypeList;
    personalData.securityLevel = this.updateScurityLevel(
      tab?.CS_SECURITY_LEVEL
    );
    if(type?.refreshFlag==true){
      /* istanbul ignore next */
     personalData.refreshFlag = type?.refreshFlag ? true :false;
    }
    personalData.customerType = tab.customerType;
    this.logger.debugLogs("setPersonDetails API paylods in Request: "+JSON.stringify(personalData), this.fileName);
    return personalData;
  }

  /**
   * Comments added in method itself.
   * @author :Pooja Gupta
   */
 
  actionBeforeGettingDomainData() {
    /**Below 3 lines are for progress Indicator to be displayed ***/
    this.startTimerForLoader();
    this.showLoaderMsg = false;
    this.domainLoader = true;

    /**Below line added  for when navigating between domains , if api is taking time to load
     * card should get emptied .i.e old data should be wiped out from the card.
     */
    this.domainData = null;
  }
  
  /* istanbul ignore next */
  getDomainDetails(tab, menu, index, refreshFlag?) {
    this.actionBeforeGettingDomainData();
    let type = {
      component: menu?.componentName,
      id: tab?.customerSessionId,
      domain: menu?.domain,
      roleType: this.rootScopeService.activeCustTab?.roleType,
      securityLevel: this.updateScurityLevel(tab?.CS_SECURITY_LEVEL),
      refreshFlag: refreshFlag
    };
    let data = this.setPersonDetails(tab, type);
    //let url = './../../assets/JSON/' + this.apiUrl(menu.componentName);
    this.apiService
      .postApi(Global.openAccountApi.getPersonData, data, 'false', Constants.apiVersions, false)
      .subscribe({
        //this.http.get<any>(url).subscribe({
        next: (res) => {

          // CCR1-15016: fall back to menu.domain so domain-based lookups (e.g. support-links diable/enable) still work on empty responses
          if (!res?.data || Object.keys(res?.data).length === 0) {
            res.data = { ...res?.data, domain: menu?.domain };
          }
          res.data['index'] = res?.data?.topics?.[0]?.id;
          this.activeTabDt[menu.domain] = res?.data;
          this.customerAccountDt[index][menu.domain] = res?.data;
          if (this.activeTabDt.domainName == menu.heading) {
            this.domainData = res?.data;
            this.domainErrMsg = 'NA';
            //this.selectedIndex = this.domainData?.topics?.[0]?.id;
            this.selectedIndex = this.domainData?.topics?.find(x => x.linkEnable == true)?.id;
          }
          if (refreshFlag && this.rootScopeService.activeCustTab.subDomainIndex)
            this.selectedIndex = this.rootScopeService.activeCustTab?.subDomainIndex;
          this.handleDomainLoaderForClose();
          this.logger.debugLogs("getDomainDetails API Response: "+JSON.stringify(res), this.fileName);
        },
        error: (error) => {
          this.logger.errorLogs("Error in getDomainDetails: "+JSON.stringify(error), this.fileName);  
          this.handleDomainLoaderForClose();
          this.domainData = null;
          this.domainErrMsg = Constants.CARD_DATA_FAILURE_MSG;
          if(this.activeTabDt)
            this.activeTabDt[menu?.domain] = this.domainData;

          if(this.customerAccountDt &&  this.customerAccountDt[index])
            this.customerAccountDt[index][menu?.domain] = this.domainData;
        },
      });
  }

  /**
   * getPersonRefreshData()-  calling getperson API again to refresh customer persistent info data.
   * @author :Amarjeet kumar
   */
  /* istanbul ignore next*/
  getPersonRefreshData(tab) {
    let type = {
      component: "PERSON-PID-DATA",
      id: tab?.customerSessionId,
      domain: "COMMON",
      roleType: this.rootScopeService.activeCustTab?.roleType,
      securityLevel: this.updateScurityLevel(tab?.CS_SECURITY_LEVEL),
      refreshFlag: true
    };
    let data = this.setPersonDetails(tab, type);
    data.openAccountProcess = true;     
    this.apiService
      .postApi(Global.openAccountApi.getPersonData, data, 'false', Constants.apiVersions, false)
      .subscribe({
        next: (res) => {
          console.log(res);
          if (res && res?.data?.lastName) {
            this.rootScopeService.activeCustTab.title = res?.data?.lastName + ', ' + res?.data?.firstName;
            this.rootScopeService.activeCustTab.isVIP = res?.data?.isVIP;
            this.rootScopeService.activeCustTab.last4DigitsOfSSN = res?.data?.last4DigitsOfSSN;
            this.rootScopeService.activeCustTab.employeeId = res?.data?.employeeId;
            this.rootScopeService.activeCustTab.employmentStatusCode = res?.data?.employmentStatusCode;
            this.rootScopeService.activeCustTab.preferredLocale = this.rootScopeService.getPreferredLocale(res?.data);
            this.rootScopeService.activeCustTab.primaryLanguage = this.rootScopeService.getPrimaryLanguage(res?.data);
            this.rootScopeService.activeCustTab.pronouns = res?.data?.pronouns;

          // CCR1-14992: Refresh the Age/Govt ID/EE ID/Status/Sector card on manual refresh too.
          // NOTE: This mirrors the normalization logic in createNewTabDTO()
          const persistentInfo = Array.isArray(res?.data?.persistentInfo) ? res.data.persistentInfo : [];
          const normalizedPersistentInfo = persistentInfo.map((item: any) => ({
            elementLabel: item?.elementLabel ?? item?.element_label ?? '',
            elementValue: item?.elementValue ?? item?.element_value ?? '',
            sequence: item?.sequence ?? 0,
            title: item?.title ?? '',
            helperAttributes: item?.helperAttributes ?? item?.helper_attributes ?? ''
          })).sort((a, b) => Number(a?.sequence) - Number(b?.sequence));
          // CCR1-14992: the dynamicItems array captures all persistentInfo items marked with the dynamic helper_attributes flag.
          const dynamicItems = normalizedPersistentInfo?.filter(
              item => String(item.helperAttributes)?.trim()?.toLowerCase() === Constants.PERSISTENT_INFO_HELPER_ATTRIBUTE.toLowerCase()
            ) ?? [];

          this.rootScopeService.activeCustTab.persistentInfo = normalizedPersistentInfo;
          this.rootScopeService.activeCustTab.clientSpecificDynamicFields = dynamicItems;
          }
        },
        error: (error) => {
          console.error('There was an error!', error);
        },
      });
  }

  /**Below method gets executed if domain API fails or success
   * Intent is to close the indicator and timer thread.
   * @author :Pooja Gupta
   */

  handleDomainLoaderForClose() {
    this.domainLoader = false;
    clearTimeout(this.loaderTimeoutId);
    this.showLoaderMsg = false;
  }

  apiUrl(component) {
    let url = '';
    switch (component) {
      case 'COMMON_DETAILS':
        url = 'common.json'; //Global.openAccountApi.common;
        break;
      case 'DEFINED-BENEFIT':
        url = 'db.json'; //Global.openAccountApi.DB;
        break;
      case 'DEFINED-CONTRIBUTION':
        url = 'dc.json'; //Global.openAccountApi.DC;
        break;
      case 'HEALTH':
        url = 'health.json'; //Global.openAccountApi.HW;
        break;
      case 'WFH':
        url = 'payTime.json'; //Global.openAccountApi.PT;
        break;
    }
    return url;
  }

  /**
   * Fetches the list of topics for a given domain from the server.
   * @param {string} clientId - The ID of the client associated with the domain.
   * @param {string} domainId - The ID of the domain to fetch topics for.
   * @returns {Observable<any>} An Observable that emits the response containing the list of topics.
   */
  getTopicListByDomain(clientId, domainId): Observable<any> {
    const url = `${Global.domainUrl}${Global.customerApi.getTopicListByDomain}`;
    const body = {
      clientId: clientId,
      domainId: domainId,
    };
    const headers = {
      headers: this.rootScopeService.getCommonHeaders(Constants.apiVersions),
    };

    return this.http.post<any>(url, body, headers);
  }

  /**
   * Retrieves Knowledge Center (KC) article and TBA links based on the provided parameters.
   * @param {string} clientId - The ID of the client for which to fetch the article links.
   * @param {string} domainId - The ID of the domain within the client's context.
   * @param {string} topicId - The ID of the topic for which to retrieve article links.
   * @returns {Observable<any>} An Observable emitting the response containing KC article and TBA links.
   */
  getTbaKcArticleLinks(
    clientId: string,
    domainId: string,
    topicId: string
  ): Observable<any> {
    const url = `${Global.domainUrl}${Global.customerApi.getTbaKcArticleLinks}`;
    const body = {
      clientId: clientId,
      domainId: domainId,
      topicId: topicId,
      // CCR1-14008 Supporting links change
      roleType: this.rootScopeService.activeCustTab?.defaultRole,
    };
    const headers = {
      // CCR1-14008 Supporting links change
      headers: this.rootScopeService.getCustAccHeaders(Constants.apiVersions, this.rootScopeService.activeCustTab.customerSessionId),

    };
    return this.http.post<any>(url, body, headers);
  }

  // getAllIHList(params, self) {
  //   this.apiService
  //     .getApi(Global.interactionHistory.getIHList, params, '', false)
  //     .subscribe({
  //       //this.http.get<any>(url).subscribe({
  //       next: (res) => {
  //         this.modifyResponseData(res.data, self)
  //         //  self.dataSource = new MatTableDataSource(res.data);
  //         console.log(res);

  //       },
  //       error: (error) => {
  //         console.error('There was an error!', error);

  //       },
  //     });
  // }
  // modifyResponseData(interHistData, self) {
  //   let that = this;
  //   interHistData.map(function (each) {
  //     let date =
  //       // console.log("date",date)
  //       each.agent = each.delegate?.name;
  //     each.channelIcon = that.channelIconMap[each.channel];
  //     each.topic = each.description;
  //     if (each.initiated) {
  //       each.channelIcon = each.channelIcon[each.initiated];
  //     }
  //     each.startTime = moment(each.begin).format('HH:mm');
  //     each.date = moment(each.begin).format('MMM-DD-YYYY');
  //     each.ConversationId = each.documentDetail?.externalRefId;
  //   })
  //   self.dataSource = new MatTableDataSource(interHistData);
  //   //  this.interHistBriefViewTableData = new MatTableDataSource(interHistData);
  // }

  // channelIconMap = {
  //   [Constants.IH_CALL]: {
  //     [Constants.IH_INTERNAL_CALL]: 'fa-light fa-phone-arrow-down-left',
  //     [Constants.IH_EXTERNAL_CALL]: 'fa-light fa-phone-arrow-up-right'
  //   },
  //   [Constants.IH_CHAT]: 'fa-light fa-message-lines',
  //   'lisa': 'fa-light fa-comment-lines',
  //   'IVR': 'fa-light fa-headset',
  //   'web': 'fa-light fa-globe',
  //   'mobile': 'fa-light fa-mobile',
  //   'documents': 'fa-light fa-folder-open',
  //   'message': 'fa-light fa-messages'
  // }
  //CCR6-1212 Below function is called to show Recording popup.
  // CCR6-1354 to show updates on recording popup.
  openRecordDialog() {
    this.rootScopeService.outBoundPopUp = true;

    this.rootScopeService.openDialog({
      title: 'Required Alert for Recorded Calls',
      subheading: 'Please read to customer:',
      message: Constants.Outbound_Call_Script,
      CCRNote:Constants.Outbound_Call_Script_Note, 
      firstbutton: Constants.buttonEnum.callNotRecorded,
      secondbutton: Constants.buttonEnum.informedCaller,
      crossIcon: false,
      comingFrom: 'customer-account',
      additionalClass: 'record-modal',
    });
  }

    /**
  * @author - Amarjeet Kumar
  * Displays a dialog informing the agent that the same customer is on another active call.
  * The dialog includes a message with instructions and a "Got It" button to acknowledge.
  * @param {string} activeAgentData - Information about the active agent handling the other call.
  */
  multipleActiveCallsDialog(activeAgentData) {
    this.rootScopeService.openDialog({
      title: 'Same customer on another Call',
      subheading: '',
      message: activeAgentData + Constants.Multiple_Active_Call_Script,
      firstbutton: '',
      secondbutton: Constants.buttonEnum.gotIt,
      crossIcon: false,
      comingFrom: 'customer-account',
      additionalClass: 'record-modal',
    });
  }
  /** @Author Jaya 
   * CCR3-12199 Launch ALIS for PIN Entry popup
  */

/* istanbul ignore next */

// CCR3-12172 Displays a confirmation dialog prompting the user to continue the PIN simulation flow.
// Returns an Observable that emits when the user clicks "Continue Simulation".

showSimulationPopup() {
      
     return this.rootScopeService.openDialog({
        title: '',
        subheading: '',
        message: Constants.Continue_Simulation_Msg,
        firstbutton: '',
        secondbutton: "Continue Simulation",
        crossIcon: false,
        comingFrom: 'authentication',
        additionalClass: 'authentication',
      });

    
  }



  /**
  * @author - Sultan Khan
  * Resets and retrieves exception and sub-exception data for the active customer tab.
  * This method initializes and clears the exception and sub-exception lists, selected types,
  * and updates the form with empty values. It then fetches the exception data from the cached
  * data if available, or makes an HTTP request if not found in the cache.
  */
  /* istanbul ignore next */
  getExceptionandSubException() {
    this.rootScopeService.activeCustTab.approvedExceptionsTypes.exceptionTypeandSubTypeAPIFailure = false;
    this.rootScopeService.activeCustTab.approvedExceptionsTypes.exceptionTypeandSubTypeAPIConfigMiss = false;
    this.rootScopeService.activeCustTab.approvedExceptionCredentialData.CredentialDataAPIConfigMiss = false;
    this.rootScopeService.activeCustTab.approvedExceptionCredentialData.CredentialDataAPIFailure = false;
    this.rootScopeService.activeCustTab.approvedExceptionEgainContentData.EgainContentConfigMiss = false;
    this.rootScopeService.activeCustTab.approvedExceptionEgainContentData.EgainContentAPIFailure = false;
    this.rootScopeService.activeCustTab.approvedExceptionResouceLinksData.resourceLinksAPIFailure = false;
    this.rootScopeService.activeCustTab.approvedExceptionResouceLinksData.resourceLinksConfigMiss = false;
    this.rootScopeService.exceptionsList = [];
    this.rootScopeService.subExceptionsList = [];
    this.rootScopeService.activeCustTab.approvedExceptionCredentialData.selectedCredentialData = [];
    this.rootScopeService.activeCustTab.approvedExceptionEgainContentData.selectedEgainContent = '';
    this.rootScopeService.activeCustTab.approvedExceptionResouceLinksData.selectedResourceLinksData = [];
    this.rootScopeService.activeCustTab.approvedExceptionsTypes.selectedSubException = '';
    this.rootScopeService.activeCustTab.approvedExceptionsTypes.selectedException = '';
    this.rootScopeService.approvedTypeExceptionForm.patchValue({
      type: '',
      subType: ''
    });

    const customerTypeFilterData = this.rootScopeService.activeCustTab.approvedExceptionsTypes
      .find((x: any) => x.exceptionsData?.customerType === this.rootScopeService.activeCustTab.customerType);

    if (customerTypeFilterData) {
      this.rootScopeService.exceptionsList = customerTypeFilterData.exceptionsData.exceptions;
    } else {
      this.getApprovedExceptionsListByClientId(this.rootScopeService.activeCustTab.customerType,false);
    }
    this.rootScopeService.activeCustTab.approvedExceptionToggleValue = false;
    this.rootScopeService.activeCustTab.isApprovedExceptionContinueDisabled = true;
    this.rootScopeService.activeCustTab.isApprovedExceptionContinueClicked = false;
  }


  /**
   * @author - Sultan Khan
   * Retrieves the approved exceptions list by customer type for the active client.
   * @param customerType The type of customer for which to fetch the exceptions list.
   */
  getApprovedExceptionsListByClientId(customerType: string, isRefreshAction: boolean): void {
    this.rootScopeService.activeCustTab.approvedExceptionsTypes.exceptionTypeandSubTypeAPIFailure = false;
    this.rootScopeService.activeCustTab.approvedExceptionsTypes.exceptionTypeandSubTypeAPIConfigMiss = false;
    this.rootScopeService.activeCustTab.approvedExceptionCredentialData.CredentialDataAPIConfigMiss = false;
    this.rootScopeService.activeCustTab.approvedExceptionCredentialData.CredentialDataAPIFailure = false;
    this.rootScopeService.activeCustTab.approvedExceptionEgainContentData.EgainContentConfigMiss = false;
    this.rootScopeService.activeCustTab.approvedExceptionEgainContentData.EgainContentAPIFailure = false;
     this.rootScopeService.activeCustTab.approvedExceptionsTypes = [];

    const clientId = this.rootScopeService.activeCustTab.clientId;
    let url = `${Global.domainUrl}${Global.customerApi.getApprovedExceptionLists}?clientId=${clientId}&customerType=${customerType}`;

    
    this.http.get(url, { headers: this.rootScopeService.getCustAccHeaders(Constants.apiVersions, this.rootScopeService.activeCustTab.customerSessionId) }).subscribe({
      next: (res: any) => {
        const exceptionsData = res?.data;
        if (exceptionsData) {
          this.rootScopeService.activeCustTab.approvedExceptionsTypes.push({ exceptionsData });
        }
        const customerTypeFilterData = this.rootScopeService.activeCustTab.approvedExceptionsTypes
          .find((x: any) => x?.exceptionsData?.customerType === customerType);


        if (customerTypeFilterData) {
          this.rootScopeService.exceptionsList = customerTypeFilterData.exceptionsData.exceptions;
           this.rootScopeService.activeCustTab.isApprovedExceptionContinueDisabled = true;
           this.rootScopeService.activeCustTab.isApprovedExceptionContinueClicked = false;
           this.rootScopeService.activeCustTab.approvedExceptionToggleValue = false;
            this.rootScopeService.activeCustTab.approvedExceptionSuccessMsg = false;
            this.rootScopeService.activeCustTab.platformTypeTableData.displayPlatformInternalIdTable = false;
            if(isRefreshAction){
              if (this.rootScopeService.activeCustTab.successAErefreshMsgTimeout) {
                clearTimeout(this.rootScopeService.activeCustTab.successAErefreshMsgTimeout);
              }
              this.rootScopeService.activeCustTab.approvedExceptionRefreshSuccessMsg = true;
              /**wipe off success msg after 10 secs */
              this.rootScopeService.activeCustTab.successAErefreshMsgTimeout = setTimeout(() => {
                  this.rootScopeService.activeCustTab.approvedExceptionRefreshSuccessMsg = false;
                }, 10000);
            }
        } else {
          this.rootScopeService.exceptionTypeandSubTypeAPIConfigMissErrorMsg = `${res?.errorResponse?.errorDescription}: ${res?.errorResponse?.message}`;
          this.rootScopeService.activeCustTab.approvedExceptionsTypes.exceptionTypeandSubTypeAPIConfigMiss = true;
        }
      },
      error: (err) => {
        this.rootScopeService.activeCustTab.approvedExceptionsTypes.exceptionTypeandSubTypeAPIFailure = true;
      }
    });
  }

  /**
   * @author Sultan Khan
   * Retrieves and manages credential data for the selected sub-exception.
   * 
   * This method is responsible for handling the retrieval and management of credential data
   * for the currently selected sub-exception within the active customer tab. It first resets
   * related flags and data, and then checks if the credential data is already available. If
   * not, it triggers a data retrieval process.
   * 
   * @param selectedSubExceptionData - The data for the selected sub-exception.
   */
  getCredetialData(selectedSubExceptionData: any) {
    this.rootScopeService.activeCustTab.approvedExceptionCredentialData.CredentialDataAPIConfigMiss = false;
    this.rootScopeService.activeCustTab.approvedExceptionCredentialData.CredentialDataAPIFailure = false;
    this.rootScopeService.activeCustTab.approvedExceptionCredentialData.selectedCredentialData = [];
    const tab = this.rootScopeService.activeCustTab;

    const credentialData = _.find(tab.approvedExceptionCredentialData, (x) => {
      return x.clientId === tab.clientId && x.customerType === tab.customerType &&
        x.exceptionType === tab.approvedExceptionsTypes.selectedException &&
        x.exceptionSubtype === tab.approvedExceptionsTypes.selectedSubException;
    });
    if (credentialData) {
      this.rootScopeService.activeCustTab.approvedExceptionCredentialData.selectedCredentialData = credentialData?.credentialData;

    } else {
      this.getDataElementsForApprovedException(selectedSubExceptionData);

    }
  }

  /**
   * @author - Sultan Khan
   * Fetches and processes credential data for an approved exception from an external API.
   * 
   * This method is responsible for making an HTTP request to an external API to retrieve
   * credential data for the selected approved exception. It processes the API response,
   * updates the credential data in the active customer tab, and handles potential errors.
   * 
   * @param selectedSubExceptionData - The data for the selected sub-exception.
   */
  getDataElementsForApprovedException(selectedSubExceptionData: any) {
    this.rootScopeService.activeCustTab.approvedExceptionCredentialData.CredentialDataAPIConfigMiss = false;
    this.rootScopeService.activeCustTab.approvedExceptionCredentialData.CredentialDataAPIFailure = false;
    const url = `${Global.domainUrl}${Global.openAccountApi.getPersonData}`;
    const tab = this.rootScopeService.activeCustTab;
    const requestData = {
      component: selectedSubExceptionData?.component_id,
      id: tab?.customerSessionId,
      domain: Constants.navMenu.authApprovedException,
      roleType: tab?.roleType,
      securityLevel: this.updateScurityLevel(tab?.CS_SECURITY_LEVEL),
    };
    const headers = this.rootScopeService.getCommonHeaders(Constants.apiVersions);
    const payload = this.setPersonDetails(tab, requestData);

    this.http.post(url, payload, { headers: headers }).subscribe({
      next: (res: any) => {
        /* istanbul ignore next */
        if (res?.data?.topics?.length > 0 && res.data.topics[0]?.groups?.length > 0) {
          let credentialData = res?.data?.topics[0]?.groups;
          const resData = {
            clientId: tab.clientId,
            exceptionType: tab.approvedExceptionsTypes.selectedException,
            exceptionSubtype: tab.approvedExceptionsTypes.selectedSubException,
            credentialData: credentialData,
            customerType: tab.customerType
          };
          this.rootScopeService.activeCustTab.approvedExceptionCredentialData.push(resData);
          this.rootScopeService.activeCustTab.approvedExceptionCredentialData.selectedCredentialData = credentialData;

        } else {
          this.rootScopeService.activeCustTab.approvedExceptionCredentialData.CredentialDataAPIConfigMiss = true;
        }
      },
      error: (err) => {
        this.rootScopeService.activeCustTab.approvedExceptionCredentialData.CredentialDataAPIFailure = true;
      }
    })
  }

  /**
   * @author - Sultan Khan
   * Retrieves and sets Egain content data based on the selected sub-exception data.
   * @param selectedSubExceptionData - The data representing the selected sub-exception.
   *It should contain a property 'content_id' for identification.
  */
  getEgainContentData(selectedSubExceptionData: any) {
    this.rootScopeService.activeCustTab.approvedExceptionEgainContentData.selectedEgainContent = '';
    this.rootScopeService.activeCustTab.approvedExceptionEgainContentData.EgainContentConfigMiss = false;
    this.rootScopeService.activeCustTab.approvedExceptionEgainContentData.EgainContentAPIFailure = false;
    const tab = this.rootScopeService.activeCustTab;
    const contentId = selectedSubExceptionData?.content_id;
    const egainContentData = tab.approvedExceptionEgainContentData.find(x => x.contentId === contentId);
    if (egainContentData) {
      this.rootScopeService.activeCustTab.approvedExceptionEgainContentData.selectedEgainContent = egainContentData?.egainContentData;
    } else {
      this.getEgainContentForApprovedException(contentId);
    }
  }

  /**
   * @author - Sultan Khan
   * Fetches Egain content for the approved exception from the server and updates the local data.
   * @param contentId - The ID of the Egain content to be fetched.
   */
  getEgainContentForApprovedException(contentId: any): void {
    this.rootScopeService.activeCustTab.approvedExceptionEgainContentData.EgainContentConfigMiss = false;
    this.rootScopeService.activeCustTab.approvedExceptionEgainContentData.EgainContentAPIFailure = false;
    const url = `${Global.domainUrl}${Global.customerApi.getEgainContent}`;
    const headers = this.rootScopeService.getCommonHeaders(Constants.apiVersions);
    const payload = { contentId };
    this.http.post(url, payload, { headers }).subscribe({
      next: (res: any) => {
        console.log(res);
        if (res && res?.data) {
          const egainContentData = JSON.parse(res.data);
          const newData = { contentId, egainContentData };
          this.rootScopeService.activeCustTab.approvedExceptionEgainContentData.push(newData);
          this.rootScopeService.activeCustTab.approvedExceptionEgainContentData.selectedEgainContent = egainContentData;
        } else {
          /* istanbul ignore next */
          this.rootScopeService.activeCustTab.approvedExceptionEgainContentData.EgainContentConfigMiss = true;
        }
      },
      error: (err) => {
        if (err.status === 404) {
          this.rootScopeService.activeCustTab.approvedExceptionEgainContentData.EgainContentConfigMiss = true;
        } else {
          this.rootScopeService.activeCustTab.approvedExceptionEgainContentData.EgainContentAPIFailure = true;
        }
      }
    });
  }

  /**
   * @author - Sultan Khan
   * Retrieves resource links for the selected sub-exception data.
   * @param selectedSubExceptionData The data of the selected sub-exception.
   */
  getResourseLinks(selectedSubExceptionData: any) {
    this.rootScopeService.activeCustTab.approvedExceptionResouceLinksData.resourceLinksAPIFailure = false;
    this.rootScopeService.activeCustTab.approvedExceptionResouceLinksData.resourceLinksConfigMiss = false;
    this.rootScopeService.activeCustTab.approvedExceptionResouceLinksData.selectedResourceLinksData = [];
    const clientId = this.rootScopeService.activeCustTab.clientId;
    const domainId = Constants.navMenu.authApprovedException;
    const topicId = selectedSubExceptionData?.links_layout_id;
    const tab = this.rootScopeService.activeCustTab;
    const resourceLinksData = tab.approvedExceptionResouceLinksData.find(x => x?.topicId === topicId);
    if (resourceLinksData) {
      this.rootScopeService.activeCustTab.approvedExceptionResouceLinksData.selectedResourceLinksData = resourceLinksData?.resourceLinksData;
      this.checkedSectionNotload(resourceLinksData?.resourceLinksData);
    } else {
      this.getTbaKcArticleLinksForApprovedException(clientId, domainId, topicId);
    }
  }


  /**
   * Retrieves KC article and TBA links for the specified client, domain, and topic, populating the links section data.
   * @param {string} clientId - The ID of the client for which to fetch the article links.
   * @param {string} domainId - The ID of the domain within the client's context.
   * @param {string} topicId - The ID of the topic for which to retrieve article links.
   */
  getTbaKcArticleLinksForApprovedException(clientId, domainId, topicId) {
    this.rootScopeService.activeCustTab.approvedExceptionResouceLinksData.resourceLinksAPIFailure = false;
    this.rootScopeService.activeCustTab.approvedExceptionResouceLinksData.resourceLinksConfigMiss = false;
    this.getTbaKcArticleLinks(clientId, domainId, topicId).subscribe({
      next: (res: any) => {
        console.log('getTbaKcArticleLinksForApprovedException links section data  : ' + JSON.stringify(res));
        const resourceLinksData = res?.data.menuList;
        if (resourceLinksData) {
          this.checkedSectionNotload(resourceLinksData);
          const newData = { topicId, resourceLinksData };
          this.rootScopeService.activeCustTab.approvedExceptionResouceLinksData.push(newData);
          this.rootScopeService.activeCustTab.approvedExceptionResouceLinksData.selectedResourceLinksData = resourceLinksData;
        }

      },
      error: (err) => {
        this.rootScopeService.activeCustTab.approvedExceptionResouceLinksData.resourceLinksAPIFailure = true;
        console.log(err);
      }
    })
  }

  /**
   * Checks if any menu section is marked as not loaded (null ID) and triggers a visual indication if found.
   * If a menu section with null ID is present, it sets a flag to display a refresh icon for links sections error.
   * @param {any[]} menuList - The list of menu sections to be checked.
   */
  checkedSectionNotload(menuList: any) {
    const checkedSectionNotload = menuList.find(
      item => item.id === null);
    if (checkedSectionNotload) {
      this.rootScopeService.activeCustTab.approvedExceptionResouceLinksData.resourceLinksConfigMiss = true;
    }
  }

  /** 
   * This function is used to determine the visual representation and behavior of the authentication status
   * in the context of a call and chats.
   * @param {string} authenticateStatus - The authentication status to be evaluated.
   * @returns {string} - The determined authentication class ('secured', 'partially-secured', 'unsecured', 'research').
   * */
    /* istanbul ignore next */
  identifyAuthenticateClass(authenticateStatus) {
    if (this.rootScopeService.isCallBackCall && this.rootScopeService.isLiveCall) {
      if (this.rootScopeService.activeCustTab.additionalAccount) {
        this.rootScopeService.activeCustTab.authenticateStatus =
          Constants.Not_Applicable;
        return (this.authenticateClass = 'research');
      } else if (authenticateStatus == Constants.FULLY_SECURED) {
        /** Below code will  be executed for callback call */
        return this.authenticateClass = 'secured'
      }
      else if (this.rootScopeService.validateNullAndEmpty(this.rootScopeService.activeCustTab.conversationId)) return (this.authenticateClass = 'unsecured');

      else {
        this.rootScopeService.activeCustTab.authenticateStatus =
          Constants.Not_Applicable;
        return (this.authenticateClass = 'research');
      }
    }

    if (authenticateStatus == Constants.FULLY_SECURED) {
      /** Below code will  be executed for inbound /outbound call */
      return (this.authenticateClass = 'secured');
    } else if (authenticateStatus == Constants.PARTIALLY_SECURED) {
      /** Below code will  be executed for inbound /outbound call */
      return (this.authenticateClass = 'partially-secured');
    } else if (authenticateStatus == Constants.UNSECURED) {
      /** Below code will  be executed for inbound /outbound call */
      return (this.authenticateClass = 'unsecured');
    } else {
      /***This is the off call case where dot color will be grey and label will be SECURED as per figma*/
      this.rootScopeService.activeCustTab.authenticateStatus = this.rootScopeService
        .activeCustTab.authenticateStatus
        ? this.rootScopeService.activeCustTab.authenticateStatus
        : Constants.SECURED;
      return (this.authenticateClass = 'research');
    }
  }

  /**
  * Checks if the given section has an IVR confirmation rule and validates it.
  * @param section - The section to be checked for IVR confirmation rule.
  * @returns A boolean indicating whether the IVR confirmation is valid or not.
  */
  checkIVRConfirmation(section: any): boolean {
    const rule = section?.rule;
    if (rule && this.checkStringStartsWithValidation(rule)) {
      const fieldname = rule.split("::")[1];
      if (fieldname) {
        return this.alisCIMDataValidation(fieldname);
      }
    }
    return false;
  }


  /**
  * Validates the given fieldname against the ALIS CIM data.
  * @param fieldname - The fieldname to be validated.
  * @returns A boolean indicating whether the field is present in the CIM data.
  */
  alisCIMDataValidation(fieldname: any): boolean {

    const cimData: string = this.rootScopeService.activeCustTab.genesysAttributes?.cimData || '';
    const isFieldPresent: boolean = cimData?.toLowerCase().includes(fieldname?.toLowerCase());

    return isFieldPresent;
  }

  /**
  * Checks if the given string starts with the required validation prefix.
  * @param str - The string to be checked for the validation prefix.
  * @returns A boolean indicating whether the string starts with the required prefix.
  */
  checkStringStartsWithValidation(str: string): boolean {
    return str.startsWith(Constants.GET_PERSON_RULE.ALIS_CIM_VALIDATION);
  }

  /**
   * Creates a dynamic FormGroup for a given array of topics, adding controls for each element
   * and including an 'additionalCheckboxKey' control. Values and validations are applied.
   * 
   * @param topics - Array of topics with nested subgroups, sections, sectionsubgroups, and elements.
   * @returns A dynamic FormGroup representing the form structure.
   */
  createDynamicForm(topics: any[]): FormGroup {
    this.rootScopeService.activeCustTab.authenticationIndicativeData.keyTitleMapping = [];
    const formGroup = this.fb.group({});
    this.indicativeDataForm = formGroup;

    let hasPostalAddress = false;
    topics.forEach(group => {
      group.subgroups.forEach(subgroup => {
        subgroup.sections.forEach(section => {
          section.sectionsubgroups.forEach(subgroup => {
            subgroup.elements.forEach(element => {
              let controlValue: any = element?.values[0]?.value;
              if (controlValue == 'NA') {
                controlValue = '';
              }
              
              let isDisabled = controlValue === undefined || controlValue === null || controlValue === '';
              if (this.rootScopeService.activeCustTab.authenticationIndicativeData.indicativeDataValueMiss) {
                isDisabled = false
              }
              if (element.title == "DOB" && !isDisabled) {
                let formattedDateString: string = this.formatDate(controlValue);
                controlValue = this.parseDateString(formattedDateString);
              }
              
              // CCR1-13262: Check if the current element is the postal address and set a flag to determine if the additional address checkbox should be added to the form.
              if (element?.title === Constants.POSTAL_ADDRESS) {
                hasPostalAddress = true;
              }

              let title = element?.title;
              let key = element?.key;

              const data = {
                key: element?.key,
                title: element?.title
              }
              formGroup.addControl(element.key, this.fb.control({ value: controlValue, disabled: !isDisabled }, [Validators.required]));
              this.rootScopeService.activeCustTab.authenticationIndicativeData.keyTitleMapping.push(data);
            });
          });
        });
      });
    });
    formGroup.addControl('additionalCheckboxKey', this.fb.control({ value: false, disabled: this.rootScopeService.activeCustTab.authenticationIndicativeData.indicativeDataValueMiss }, [Validators.required]));
     // CCR1-13262: Add the address verification checkbox only when postal address data is present; keep it disabled while indicativeDataValueMiss is true 
    if (hasPostalAddress) {
      formGroup.addControl('additionalAddressCheckboxKey', this.fb.control({ value: false, disabled: this.rootScopeService.activeCustTab.authenticationIndicativeData.indicativeDataValueMiss }, [Validators.required]));
    }
    return formGroup;
  }

  /**
   * Formats a date string into a localized date string with a short month, 2-digit day, and numeric year.
   * @param {string} dateString - The input date string to be formatted.
   * @returns {string} - The formatted date string.
   */
  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
  }

  /**
   * Parses a date string into a Date object.
   * @param {string} dateString - The input date string to be parsed.
   * @returns {Date} - The parsed Date object.
   */
  parseDateString(dateString: string): Date {
    return new Date(dateString);
  }

  /**
   * Subscribes to changes in the value of the indicative data form and logs the changes.
   * Additionally, updates the indicative data form data in the root scope service.
   */
  indicativeDataFormSubscription() {
    this.indicativeDataForm.valueChanges.subscribe(indicativeDataFormData => {
      this.rootScopeService.activeCustTab.authenticationIndicativeData.indicativeDataFormData = indicativeDataFormData;
    });
  }

  /**
   * Retrieves and processes indicative data for authentication.
   * If indicative data is not available, it fetches it using the appropriate method.
   */
  getIndicativeData() {
    const configMiss = this.rootScopeService.activeCustTab?.authenticationIndicativeData?.indicativeDataAPIConfigMiss;
    const indicativeData = this.rootScopeService.activeCustTab?.authenticationIndicativeData?.indicativeData;
    if (!indicativeData || indicativeData.length === 0) {
      if (!configMiss) {
        this.getIndicativeDataForAuthentication();
      }
    }
  }


  /**
   * Retrieves indicative data for authentication from the server and updates the active customer tab.
   * If successful, updates the indicative data and creates a dynamic form.
   * If there is an error, sets appropriate flags to indicate failure or configuration miss.
   */
  /* istanbul ignore next */
  getIndicativeDataForAuthentication() { 
    this.rootScopeService.activeCustTab.authenticationIndicativeData.indicativeDataAPIFailure = false;
    this.rootScopeService.activeCustTab.authenticationIndicativeData.indicativeDataAPIConfigMiss = false;
    this.rootScopeService.activeCustTab.authenticationIndicativeData.indicativeDataValueMiss = false;
    this.rootScopeService.activeCustTab.authenticationIndicativeData.indicativeData = [];
    this.rootScopeService.activeCustTab.authenticationIndicativeData.indicativeDataFormData = {};
    const selectedAuthenticationContent = this.rootScopeService.activeCustTab.authenticationContents?.selectedAuthenticationContent;
    const authenticationData = _.find(selectedAuthenticationContent, (x) => {
      return x?.securityMethodCode == Constants.AuthMenu.IND_DATA;
    });
    if (!authenticationData) {
      return;
    }
    const url = `${Global.domainUrl}${Global.openAccountApi.getPersonData}`;
    const tab = this.rootScopeService.activeCustTab;
    const indicatorPropName = tab?.Config_DesktopIndicator
      ? `${Constants.AUTH_IND_LAYOUT}-${tab.Config_DesktopIndicator}`
      : Constants.AUTH_IND_LAYOUT;
    const clientProps = this.rootScopeService.clientPropDataMap.get(tab?.clientId) ?? [];
    const baseProps = this.rootScopeService.clientPropDataMap.get(Constants.BASE_CLIENTID) ?? [];
    const layoutProp =
      clientProps.find((p: any) => p?.propertyName === indicatorPropName) ??
      baseProps.find((p: any) => p?.propertyName === indicatorPropName) ??
      baseProps.find((p: any) => p?.propertyName === Constants.AUTH_IND_LAYOUT);
    const layout = layoutProp?.parsedObjectData ?? null;
    const requestData = {
      component: layout?.component ?? authenticationData?.componentName,
      id: tab?.customerSessionId,
      domain: Constants.navMenu.indicativeData,
      roleType: tab?.roleType,
      securityLevel: this.updateScurityLevel(tab?.CS_SECURITY_LEVEL),
    };
    const headers = this.rootScopeService.getCommonHeaders(Constants.apiVersions);
    const payload = this.setPersonDetails(tab, requestData);

    this.http.post(url, payload, { headers: headers }).subscribe({
      next: (res: any) => {
        if (res?.data?.topics?.length > 0 && res.data.topics[0]?.groups?.length > 0) {
          let indicativeData = res?.data?.topics[0]?.groups;
          
          this.rootScopeService.activeCustTab.authenticationIndicativeData.indicativeDataValueMiss = this.isValueNA(indicativeData);
          this.rootScopeService.activeCustTab.authenticationIndicativeData.indicativeData = indicativeData;
          this.indicativeDataForm = this.createDynamicForm(indicativeData);
          this.indicativeDataFormSubscription();

        } else {
          this.rootScopeService.activeCustTab.authenticationIndicativeData.indicativeDataAPIConfigMiss = true;
        }
      },
      error: (err) => {
        this.rootScopeService.activeCustTab.authenticationIndicativeData.indicativeDataAPIFailure = true;
      }
    })
  }

  /**
 * Checks if the value 'NA' is present in the provided data array.
 * @param data - The array of data to be checked.
 * @returns True if 'NA' is found, otherwise false.
 */
  isValueNA(data: any[]): boolean {
    try {
      for (const item of data) {
        for (const subgroup of item?.subgroups) {
          if (subgroup?.sections?.length == 0) {
            return true;
          }
          for (const section of subgroup?.sections) {
            for (const element of section?.sectionsubgroups[0]?.elements) {
              if (element?.values[0]?.value === 'NA') {
                return true;
              }
            }
          }
        }
      }
      return false;
    }
    catch (err) {
      return true;
    }
  }

  /** 
    * @author - Vamsi
    *  Below method update the value of customer type of customer account in ALIS Customer Attributes
    *  if the user on live call.*/

  callerTypeValidation() {
    let activedTab = this.rootScopeService.activeCustTab;

    return !(activedTab.channel == Constants.conversion.research || (activedTab.activeCall && !activedTab.additionalAccount));
  }

  /**
   * @author - Vamsi
   * based call/chat/research.additional account role type drop down will enable and disable 
  */
  roleTypeValidation() {
    let activedTab = this.rootScopeService.activeCustTab;

    return !(activedTab.channel == Constants.conversion.research || activedTab.activeCall || activedTab.activeChat);

  }

  customerTypeValidation() {
    let activedTab = this.rootScopeService.activeCustTab;

    return ((activedTab?.activeCall || activedTab?.activeChat) && !activedTab?.additionalAccount);

  }

  /**
   * 
   * @param tab active tab 
   * @returns validate for authenitcation method acess process 
   */
  validateAuthAccess(tab: Tab) {
    let clientConfig, authAccess, MethodName;
    clientConfig = this.rootScopeService.authMethodConfig.get(tab?.clientId);
    if (tab.genesysAttributes?.CS_AUTH_CD) {
      authAccess = clientConfig?.find(x => x?.customerType == this.rootScopeService.callertTypeValue?.newTypeValue
        && (x.securityMethodCode == tab.genesysAttributes?.CS_AUTH_CD || x.securityMethodCode == Constants.AuthMenu['PIN_FSBA']) && this.lineOfBusinessValidation(x.platformSupport));

      if (authAccess) {
        return true;
      } else {
        return false;
      }
    } else return false;
  }

    /**
   * 
   * @param platform_support check the platform support for the auth method inlcusion type of exlusion type
   * @returns 
   */
    lineOfBusinessValidation(platform_support) {
      const tabData = this.rootScopeService.activeCustTab;
      
      return (tabData?.Config_DesktopIndicator &&
        (platform_support?.INCLUSION?.includes(tabData?.Config_DesktopIndicator) || platform_support?.INCLUSION?.includes('*')
        || (platform_support?.EXCLUSION && (!platform_support?.EXCLUSION?.includes(tabData?.Config_DesktopIndicator) && !platform_support?.EXCLUSION?.includes('*')))));
    }

  /**
   * 
   * @returns attribute values when user change callerType from customer account
   * update tab and genesys attrubute 
   */
  getAttributeModel() {
    let attribute, GEN_Attributes;
    attribute = {
      CUSTOMER_TYPE: this.rootScopeService.activeCustTab.customerType,
      CS_CALLER_TYPE: this.rootScopeService.activeCustTab.customerType, //added to transfer call from CSPro to Care Portal
    };

    GEN_Attributes = this.rootScopeService.activeCustTab?.genesysAttributes;

    switch (true) {
      case GEN_Attributes.CS_AUTH_CD == Constants.AuthCode.APE:
        attribute['CP_APPROVED_EXCPTION_SECURED'] = (GEN_Attributes?.CP_APPROVED_EXCPTION_SECURED == true ? false : true);
        attribute['CS_AUTH_CD'] = (attribute?.['CP_APPROVED_EXCPTION_SECURED'] == true ? Constants.AuthCode.APE : '');
        this.rootScopeService.activeCustTab.genesysAttributes.CP_APPROVED_EXCPTION_SECURED = attribute['CP_APPROVED_EXCPTION_SECURED'];
        this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL = attribute['CP_APPROVED_EXCPTION_SECURED'] ? Constants.securityLevels.SL4 : Constants.securityLevels.SL2;
        this.rootScopeService.activeCustTab.iconClass = attribute['CP_APPROVED_EXCPTION_SECURED'] ? 'green' : 'red';
        this.rootScopeService.activeCustTab.authenticateStatus = attribute['CP_APPROVED_EXCPTION_SECURED'] ? Constants.FULLY_SECURED : Constants.UNSECURED;
        break;
      case GEN_Attributes.CS_AUTH_CD == Constants.AuthCode['IND-DATA']:
        attribute['CP_INDICATIVE_DATA_SECURED'] = (GEN_Attributes?.CP_INDICATIVE_DATA_SECURED == true ? false : true);
        attribute['CS_AUTH_CD'] = (attribute?.['CP_INDICATIVE_DATA_SECURED'] == true ? Constants.AuthCode['IND-DATA'] : '');
        this.rootScopeService.activeCustTab.genesysAttributes.CP_INDICATIVE_DATA_SECURED = attribute['CP_INDICATIVE_DATA_SECURED'];
        this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL = attribute['CP_INDICATIVE_DATA_SECURED'] ? Constants.securityLevels.SL4 : Constants.securityLevels.SL2;
        this.rootScopeService.activeCustTab.iconClass = attribute['CP_INDICATIVE_DATA_SECURED'] ? 'green' : 'red';
        this.rootScopeService.activeCustTab.authenticateStatus = attribute['CP_INDICATIVE_DATA_SECURED'] ? Constants.FULLY_SECURED : Constants.UNSECURED;
        this.rootScopeService.activeCustTab.pinEntryApp.indValidMsg = attribute['CP_INDICATIVE_DATA_SECURED'] ?  true : false;
        break;
         /* istanbul ignore next */
        case GEN_Attributes.CS_AUTH_CD == Constants.AuthCode['PIN']:
          attribute['CS_AUTH_CD'] = Constants.AuthCode['PIN'];
          attribute['PINV'] = (this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) ? Constants.PINV_ATTRIBUTES.IDENTIFIED_UNSECURED : Constants.PINV_ATTRIBUTES.FULLY_SECURED;
          this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL = this.rootScopeService.activeCustTab.pinEntryApp.success == 'true' ? Constants.securityLevels.SL4 :  (this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) ? Constants.securityLevels.SL2 : Constants.securityLevels.SL4;
          this.rootScopeService.activeCustTab.iconClass = this.rootScopeService.activeCustTab.pinEntryApp.success == 'true' ? 'green' :  (this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) ? 'green' : 'red';
          this.rootScopeService.activeCustTab.authenticateStatus =  this.rootScopeService.activeCustTab.pinEntryApp.success == 'true' ? Constants.FULLY_SECURED : (this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) ? Constants.FULLY_SECURED : Constants.UNSECURED;
          attribute['CS_SECURITY_LEVEL']= this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL;
          break;
     /* istanbul ignore next */
      case (GEN_Attributes.CS_AUTH_CD == Constants.AuthCode.EA):
      case (GEN_Attributes.CS_AUTH_CD == Constants.AuthCode.PINRESET):
      case (GEN_Attributes.CS_AUTH_CD == Constants.AuthCode.SQA):
      case (GEN_Attributes.CS_AUTH_CD == Constants.AuthCode.FTU):
      case (GEN_Attributes.CS_AUTH_CD == Constants.AuthCode.MB):
      case (GEN_Attributes.CS_AUTH_CD == Constants.AuthCode.OTC):
      case (GEN_Attributes.CS_AUTH_CD == Constants.AuthCode.PIN):
      case (GEN_Attributes.CS_AUTH_CD == Constants.AuthCode.AIDV):
        this.rootScopeService.activeCustTab.iconClass = (this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) ? 'red' : 'green';
        this.rootScopeService.activeCustTab.authenticateStatus = (this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) ? Constants.UNSECURED : Constants.FULLY_SECURED;
        attribute['PINV'] = (this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) ? Constants.PINV_ATTRIBUTES.IDENTIFIED_UNSECURED : Constants.PINV_ATTRIBUTES.FULLY_SECURED;
        attribute['CS_AUTH_CD'] = (this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) ? '' : this.rootScopeService.activeCustTab.genesysAttributes?.CS_AUTH_CD;
        this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL = (this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) ? Constants.securityLevels.SL2 : Constants.securityLevels.SL4;
        attribute['CS_SECURITY_LEVEL']= this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL;
        this.authMethdsSuccessMsg(this.rootScopeService.activeCustTab.genesysAttributes);
        break;
      case (GEN_Attributes.PINV == Constants.PINV_ATTRIBUTES.FULLY_SECURED):
        this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL = Constants.securityLevels.SL2;
        this.rootScopeService.activeCustTab.iconClass = 'red';
        this.rootScopeService.activeCustTab.authenticateStatus = Constants.UNSECURED;
        attribute['PINV'] = Constants.PINV_ATTRIBUTES.IDENTIFIED_UNSECURED;
        this.rootScopeService.activeCustTab.genesysAttributes.PINV = Constants.PINV_ATTRIBUTES.IDENTIFIED_UNSECURED;
        break;
      case (GEN_Attributes.PINV == Constants.PINV_ATTRIBUTES.IDENTIFIED_UNSECURED):
        this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL = Constants.securityLevels.SL4;
        this.rootScopeService.activeCustTab.iconClass = 'green';
        this.rootScopeService.activeCustTab.authenticateStatus = Constants.FULLY_SECURED;
        attribute['PINV'] = Constants.PINV_ATTRIBUTES.FULLY_SECURED;
        this.rootScopeService.activeCustTab.genesysAttributes.PINV = Constants.PINV_ATTRIBUTES.FULLY_SECURED;
        break;

      default: attribute;
        break;
    }
   
    return attribute;
  }
  /**
   * 
   * @returns Validate auth status in indicative data success message
   */
  authSucessMsg() {
    return ((this.rootScopeService.isLiveCall || this.rootScopeService.isLiveChat) && this.rootScopeService.activeCustTab.genesysAttributes.CS_AUTH_CD == Constants.AuthCode['IND-DATA'] && this.rootScopeService.activeCustTab?.genesysAttributes?.CP_INDICATIVE_DATA_SECURED == true && this.rootScopeService.activeCustTab.pinEntryApp.indValidMsg == true)
  }

  /**
   * Below method check the default service for the client and check the index of that default service from
   *  the card multiple servies services and assign it to rootscope clientInfoCardDefaultServiceIndex variable.
   */
  defaultServiceOnLoad() {
    const clientId = this.rootScopeService.activeCustTab?.clientId;
    const defaultService = this.rootScopeService.clientInfoCard.defaultClientInfoServiceVSClientIdMap?.[clientId]?.service;

    let defaultCardsIndex = 0;

    if (defaultService && this.rootScopeService.clientInfoCard.clientInfoVSClientIdMap?.[clientId]) {
      const defaultCards = this.rootScopeService.clientInfoCard.clientInfoVSClientIdMap[clientId]
        .find(x => x?.parsedObjectData?.['Service'] == defaultService);

      if (defaultCards) {
        defaultCardsIndex = this.rootScopeService.clientInfoCard.clientInfoVSClientIdMap[clientId].indexOf(defaultCards);
      }
    }

    this.rootScopeService.clientInfoCard.clientInfoCardDefaultServiceIndex = defaultCardsIndex;
  }

  /**
* Retrieves client information card default service API.
* @param clientId The unique identifier of the client.
* @returns An observable emitting the response from the API call.
*/
  getClientInfoCardDefaultServiceApi(clientId: string): Observable<any> {
    const url = `${Global.domainUrl}${Global.customerApi.clientInfoCardDefaultPinService}/${clientId}`;
    const headers = this.rootScopeService.getCommonHeaders(Constants.apiVersions);

    return this.http.get(url, { headers });
  }

  /**
* Updates client information card default service API.
* @param clientId The unique identifier of the client.
* @param service The service to be updated.
* @returns An observable emitting the response from the API call.
*/
  updateClientInfoCardDefaultServiceApi(clientId: string, service: string): Observable<any> {
    const url = `${Global.domainUrl}${Global.customerApi.clientInfoCardDefaultPinService}`;
    const payload = { clientId, service };
    const headers = this.rootScopeService.getCommonHeaders(Constants.apiVersions);

    return this.http.post(url, payload, { headers });
  }

  /**
  * Retrieves client information card default service.
  * @param clientId The unique identifier of the client.
  */
  getClientInfoCardDefaultService(clientId: string) {
    if (this.rootScopeService.clientInfoCard.defaultClientInfoServiceVSClientIdMap?.[clientId]) {
      this.defaultServiceOnLoad();
      return;
    }

    this.getClientInfoCardDefaultServiceApi(clientId).subscribe({
      next: (res: any) => {
        const data = res?.data || { clientId, service: 'NA' };
        if (clientId)
          this.rootScopeService.clientInfoCard.defaultClientInfoServiceVSClientIdMap[clientId] = data;

        this.defaultServiceOnLoad();
      },
      error: (err) => {
        console.log(err);
        const data = { error: Constants.getClientInfoCardDefaultServiceApiFail };
        if (clientId)
          this.rootScopeService.clientInfoCard.defaultClientInfoServiceVSClientIdMap[clientId] = data;
      }
    });
  }

  /**
* Updates client information card default service.
* @param clientId The unique identifier of the client.
* @param service The service to be updated.
*/
  updateClientInfoCardDefaultService(clientId: string, service: string) {
    this.updateClientInfoCardDefaultServiceApi(clientId, service).subscribe({
      next: (res: any) => {
        delete this.rootScopeService.clientInfoCard.defaultClientInfoServiceVSClientIdMap?.[clientId];
        this.getClientInfoCardDefaultService(clientId);
      },
      error: (err) => {
        console.log(err);
        if (clientId)
          this.rootScopeService.clientInfoCard.defaultClientInfoServiceVSClientIdMap[clientId].error = Constants.updateClientInfoCardDefaultServiceApiFail;
      }
    });
  }


  /**
 * Below method check if there is any backend API fail for the update/create default pin
 *  for particular client then it return true.
 * @returns Boolean
 */
  checkCreateUpdateDefaultPinApiFail() {
    const clientId = this.rootScopeService.activeCustTab?.clientId;
    const updateServiceError = this.rootScopeService.clientInfoCard.defaultClientInfoServiceVSClientIdMap?.[clientId]?.error;

    if (updateServiceError == Constants.updateClientInfoCardDefaultServiceApiFail) return true;
    return false;
  }

   /**
     * Below method check if there is any backend API fail for the load default pin
     *  for particular client then it return true.
     * @returns Boolean
     */  checkDefaultPinLoadApiFail() {
    const clientId = this.rootScopeService.activeCustTab?.clientId;
    const defaultServiceError = this.rootScopeService.clientInfoCard.defaultClientInfoServiceVSClientIdMap?.[clientId]?.error;

    if (defaultServiceError == Constants.getClientInfoCardDefaultServiceApiFail) return true;
    return false;
  }

  /**
   * Below method invoke on Try again link on red alert message shown on the load default pin 
   * for the particular client fail.  
   */
  getDefaultPin() {
    const clientId = this.rootScopeService.activeCustTab?.clientId;
    this.getClientInfoCardDefaultService(clientId);
  }

  SAuthEnableValidation(): void {
    const sessionId = this.rootScopeService.activeCustTab?.customerSessionId;
    const SAuthModel = this.rootScopeService.authConfigUserDataMap?.[sessionId] as sAuthModel;

    if (!SAuthModel) {
      return;
    }
    const isSL4 = this.rootScopeService.activeCustTab?.CS_SECURITY_LEVEL === Constants.securityLevels.SL4;
    // Simulation mode override: treat SL4 FTU users as PASS with valid PIN
    const isSimulationSL4FTU =
      this.rootScopeService.simulationData?.isSimulationModeActive &&
      isSL4 &&
      SAuthModel.personStatus === Constants.AuthCode.FTU;

    if (isSimulationSL4FTU) {
      SAuthModel.personStatus = 'PASS';
      SAuthModel.voicePinOnFile = 'true';
      SAuthModel.voicePinStatus = Constants.SAuthStatus.VALID;
    }

    const { personStatus, voicePinStatus, voicePinOnFile, remainingPswdAttempt } = SAuthModel;
    const hasRemainingAttempts = remainingPswdAttempt >= 0;
    const isAllowed = personStatus === Constants.SAuthStatus.ALLOW;
  

    if (personStatus === Constants.SAuthStatus.AF) {
      // AF status: no action needed - reserved for future handling
    } else if (personStatus === Constants.AuthCode.FTU) {
      // CCR3-12986: First Time User - enable FTU and PINRESET flows
      SAuthModel.FTU = true;
      SAuthModel.PINRESET = true;
      SAuthModel.MB = true;
    } else if (
      hasRemainingAttempts &&
      isAllowed &&
      (voicePinStatus === Constants.SAuthStatus.NOF ||
        voicePinStatus === Constants.SAuthStatus.LOCKED ||
        voicePinStatus === Constants.SAuthStatus.EXPIRED)
    ) {
      // CCR3-12211: PIN Reset changes for expired PIN
      if (voicePinStatus === Constants.SAuthStatus.EXPIRED) {
        SAuthModel.PIN = true;
        SAuthModel.PINCNG = true;
        SAuthModel.MB = true;
      }

      // CCR3-12986: NOF with no PIN on file treated as FTU flow
      if (voicePinStatus === Constants.SAuthStatus.NOF && voicePinOnFile === false) {
        SAuthModel.PINRESET = true;
        SAuthModel.FTU = true;
        SAuthModel.MB = true;
      } else {
        SAuthModel.OTC = true;
        SAuthModel.PINRESET = true;
        SAuthModel.MB = true;
      }
    } else if (hasRemainingAttempts && voicePinStatus === Constants.SAuthStatus.VALID && voicePinOnFile) {
      // Valid PIN on file - enable all auth options
      SAuthModel.OTC = true;
      SAuthModel.PINRESET = true;
      SAuthModel.PIN = true;
      SAuthModel.PINCNG = true;
      SAuthModel.MB = true;
    } else if (hasRemainingAttempts && isSL4) {
      // SL4 fallback - allow PIN change and reset
      SAuthModel.PINRESET = true;
      SAuthModel.PINCNG = true;
    }

    this.rootScopeService.accountSAuthConfig = SAuthModel;
    this.rootScopeService.authConfigUserDataMap[sessionId] = SAuthModel;
  }

  /**
   * noPinSAuthModelValidation()- Added this for US CCR3-11602 (No PIN model clients)
   * This method validates the SAuthModel for authentication methods based on the user's status and voice pin status.
   * It updates the SAuthModel with appropriate flags for FTU, OTC, and PINRESET based on the conditions met.
   */
  noPinSAuthModelValidation() {
    let SAuthModel = this.rootScopeService.authConfigUserDataMap?.[this.rootScopeService.activeCustTab.customerSessionId];

    if (SAuthModel) {    
    
      if ( SAuthModel?.personStatus == Constants.AuthCode.FTU) {
        SAuthModel.FTU = true; 
        SAuthModel.MB = true;
      } 
      else if (SAuthModel?.remainingPswdAttempt >= 0 && SAuthModel?.personStatus == Constants.SAuthStatus.ALLOW
        && (SAuthModel.voicePinStatus ==  Constants.SAuthStatus.NOF ||
           SAuthModel.voicePinStatus ==  Constants.SAuthStatus.LOCKED ||
            SAuthModel.voicePinStatus ==  Constants.SAuthStatus.EXPIRED)) {
        SAuthModel.OTC = true; 
      } 
      else if (SAuthModel?.remainingPswdAttempt >= 0 && SAuthModel.voicePinStatus ==  Constants.SAuthStatus.VALID && SAuthModel.voicePinOnFile) {
        SAuthModel.OTC = true; SAuthModel.MB=true;
      }
     
      this.rootScopeService.accountSAuthConfig= SAuthModel;
      this.rootScopeService.authConfigUserDataMap[this.rootScopeService.activeCustTab.customerSessionId]=SAuthModel;
     
    }
  }

  disableDomainLink(nestedMenu) {
    let tabData = this.rootScopeService.activeCustTab;

    // CCR1-13388 FSBA Client i.e. 14470 must be allowed to access these domain links even when IND-DATA + SL4 live-call , disable rule would otherwise apply.
    if (tabData.CS_SECURITY_LEVEL == Constants.securityLevels.SL4 && tabData.genesysAttributes.CS_AUTH_CD == Constants.AuthCode['IND-DATA'] && Constants.DISABLE_DOMAIN_LINK[nestedMenu?.domain] && this.rootScopeService.isLiveCall && tabData?.clientId !== Constants.FSBA_CLIENT_ID) {
      return true;
    }
    /**CCR3-7551 shared acess-chat */
    if (tabData?.defaultRole == Constants.SHARED_ACCESS && tabData?.channel == Constants.conversion.chat) {
      if (nestedMenu?.id == Constants.sharedAccChat.custInfoHealth || nestedMenu?.id == Constants.sharedAccChat.custInfoCom) {
        return true;
      }
    }
    return !nestedMenu?.linkEnable;

  }

   /**
     * Refreshes the domain topics by removing the cached domain from the active customer tab.
     * If a cached domain with a specific name exists, it is removed from the domainsTopics array.
     * This method ensures that the displayed domain topics stay up-to-date.
     */
    refreshDomain() {
      const activeCustTab = this.rootScopeService.activeCustTab;
      const domainNameToRemove = activeCustTab?.domainIndex?.domainName;
      if (domainNameToRemove) {
        activeCustTab.domainsTopics = activeCustTab?.domainsTopics?.filter(item => item?.domainId !== domainNameToRemove);
      }
      // CCR3-5346 managed method to accomadate the latest individual card data  
      let tabIndex = this.customerAccountDt?.findIndex(
        (x) => x?.id == this.rootScopeService?.activeCustTab?.customerSessionId
      );
      this.refreshFlag = true
      this.getDomainDetails(
        this.rootScopeService?.activeCustTab,
        this.rootScopeService?.activeCustTab?.selectedLeftNavMenu,
        tabIndex,
        this.refreshFlag
      );
    }
/**
 * 
 * @param tab active tab
 * @returns check the AAAS enabled client or not
 * CCR3-9989
 */
    public getAaasEnabledClient(tab: Tab) {
      try {
        
      
        this.apiService.getApi(Global.authenticationApis.getAaasEnabledClient, { clientId: tab?.clientId }, 'false', false).subscribe({
        next: (res) => {  
          if(res?.data) {
            try {
              let AaasRes = JSON.parse(res?.data)?.[0];
              tab.IS_AAAS_ENABLED = AaasRes?.expr_uce?.IS_AAAS_ENABLED;
              this.identifyClientType(tab);
              
            }
            catch (err) {
              this.rootScopeService.activeCustTab.IS_AAAS_ENABLED = false;
              this.accountFreezeService.getAccountFreezeStatusFromServer();
              this.getAuthMethods(tab);
              this.logger.errorLogs("Error in getAaasEnabledClient: "+JSON.stringify(err), this.fileName);  
          }
        }
        },
        error: (err) => {
          this.logger.errorLogs("Error in getAaasEnabledClient: "+JSON.stringify(err), this.fileName);  
         
        }
      });  

      // if(tab?.CS_SECURITY_LEVEL == '1' && this.rootScopeService.isLiveCall&&!tab?.genesysAttributes.ENC_CS_CUSTOMER_ID ){
      //   this.rootScopeService.activeCustTab.genesysAttributes=Object.assign(new GEN_attributes, this.rootScopeService.getCustomerData());
      // }
    } catch (error) {
      this.logger.errorLogs("Error in getAaasEnabledClient: "+JSON.stringify(error), this.fileName);  
          
    }
    }

    identifyClientType(tab: Tab) {
      if(tab.IS_AAAS_ENABLED && !this.aaasService.AaaSFieldListData?.[this.rootScopeService.activeCustTab.clientId]){
        this.aaasService.getAaaSFtuFieldData();
      }
      else if(tab.IS_AAAS_ENABLED){
        this.aaasService.getAaasUserAuthMethod(true);
      }
      else{
        
        this.getAuthMethods(tab);
      }

      this.accountFreezeService.getAccountFreezeStatusFromServer();
    }

    /**
     * Retrieves the health coverage data for the active customer tab.
     * This method makes an HTTP POST request to the specified URL to fetch the data.
     * If the request is successful, the retrieved health coverage data is stored in the active customer tab.
     * If no health coverage data is found, the 'healthCardConfigMiss' flag is set to true.
     * If there is an error in the API request, the 'healthCardApiFailure' flag is set to true.
     */
    getHealthCoverageData() {
      this.rootScopeService.activeCustTab.approvedExceptionHealthCardData.healthCardApiFailure = false;
      this.rootScopeService.activeCustTab.approvedExceptionHealthCardData.healthCardConfigMiss = false;

      const url = `${Global.domainUrl}${Global.openAccountApi.getPersonData}`;
      const tab = this.rootScopeService.activeCustTab;
      const type = {
        component: 'HW-CURRENT-COVERAGE',
        id: tab?.customerSessionId,
        domain: 'HM',
        roleType: tab?.roleType,
        securityLevel: this.updateScurityLevel(tab?.CS_SECURITY_LEVEL),
        refreshFlag: false,
        planTypeList: this.rootScopeService?.planTypesForHealthCard
      };
      const data = this.setPersonDetails(tab, type);
      const headers = this.rootScopeService.getCommonHeaders(Constants.apiVersions);

      this.http.post(url, data, { headers }).subscribe({
        next: (res: any) => {
          const healthCoverageData = res?.data?.hwCondensedDTOList;
          if (healthCoverageData?.length > 0) {
            this.rootScopeService.activeCustTab.approvedExceptionHealthCardData.healthCardData = healthCoverageData?.sort((a, b) => {
              return this.rootScopeService?.planTypesForHealthCard?.indexOf(a?.planTypeName) - this.rootScopeService?.planTypesForHealthCard?.indexOf(b?.planTypeName);
            });
          } else {
            this.rootScopeService.activeCustTab.approvedExceptionHealthCardData.healthCardConfigMiss = true;
          }
        },
        error: (err) => {
          this.rootScopeService.activeCustTab.approvedExceptionHealthCardData.healthCardApiFailure = true;
        }
      });
    }


  /**
   * Retrieves health coverage data for approved exceptions.
   * If the active customer tab has health card data for approved exceptions, it returns without performing any action.
   * Otherwise, it calls the getHealthCoverageData method to retrieve the data.
   */
  getHealthCoverageDataForApprovedException() {
    if (this.rootScopeService.activeCustTab?.approvedExceptionHealthCardData?.healthCardData?.length > 0) {
      return;
    } else {
      this.getHealthCoverageData();
    }
  }

  authMethdsSuccessMsg(GEN_Attributes: GEN_attributes) {
    if (this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL == Constants.securityLevels.SL2) {

      if (GEN_Attributes.CS_AUTH_CD == Constants.AuthCode.PIN) {
        this.rootScopeService.activeCustTab.pinEntryApp.success = 'false';
      }
       else if (GEN_Attributes.CS_AUTH_CD == Constants.AuthCode.OTC) {
        this.rootScopeService.activeCustTab.otcData.validateOtcSuccess = false;
      }
    }
    else if (this.rootScopeService.activeCustTab.CS_SECURITY_LEVEL == Constants.securityLevels.SL4) {

      if (GEN_Attributes.CS_AUTH_CD == Constants.AuthCode.PIN) {
        this.rootScopeService.activeCustTab.pinEntryApp.success = 'true';
      } 
      else if (GEN_Attributes.CS_AUTH_CD == Constants.AuthCode.OTC) {
        this.rootScopeService.activeCustTab.otcData.validateOtcSuccess = true;
      }
    }
  }

  /** CCR3-11152
   * @author- Amarjeet Kumar
   * @description - Below method is used to show the dialog if there is any multiple active call for the agent
   * @param tab active tab
   */
  checkAgentForActiveCall(tab) {
    this.activeAgentCallApi(tab).subscribe({
      next: (res: any) => {
        if (res && res?.['data'] && res['data']?.isCallActive) {          
          tab['activeAgentData'] = res?.['data'];
          this.rootScopeService.activeCustTab['agentDetails'] = res?.['data'];
          let activeAgentData = res?.['data']?.delegate?.name + '(ID:' + res['data']?.delegate?.delegateId + ') ';
          if (!this.rootScopeService.activeCustTab.additionalAccount) { // added condition to avoid additional account case
            this.multipleActiveCallsDialog(activeAgentData);
          }
        }
      },
      error: (error) => {
        this.logger.errorLogs("Error in multiple active call API: " + JSON.stringify(error), this.fileName);
      },
    });
  
    }
  

  activeAgentCallApi(tab) {
    let url = Global.domainUrl + Global.CHECK_MULTIPLE_ACTIVE_CALL;
    let payload = {
      conversationId: tab.conversationId
    }
    return this.http.post(url, payload, {
      headers: this.rootScopeService.getCustAccHeaders(Constants.apiVersions, tab.customerSessionId)
    });
  }

  getClearIdentityVerfication(tab) {
    if (tab.clientId && this.rootScopeService.clearClientMap.has(tab.clientId)) {
      tab.clearIdentityData.isClearIdentityEnabled = this.rootScopeService.clearClientMap.get(tab.clientId);
    } else {
      //this.rootScope.activeCustTab.tabData.tabData.
    
      this.apiService.getApi(Global.CLEAR_APIS.CLEAR_IDENTITY_VERIFICATION, { clientId: tab?.clientId }, 'false', false).subscribe({
        next: (res) => {
          if (res && res?.data) {
            try {
              tab.clearIdentityData.isClearIdentityEnabled = JSON.parse(res.data)?.IS_IDV_ENABLED=="true"? true : false;
              this.rootScopeService.clearClientMap.set(tab.clientId, tab.clearIdentityData.isClearIdentityEnabled);

            } catch (error) {
              tab.clearIdentityData.isClearIdentityEnabled = false;
              this.logger.errorLogs("Error in parsing IS_IDV_ENABLED: " + JSON.stringify(error), this.fileName);
            }

          }
        },
        error: (error) => {
          tab.clearIdentityData.isClearIdentityEnabled = false;
          this.logger.errorLogs("Error in parsing IS_IDV_ENABLED: " + JSON.stringify(error), this.fileName);
        }
      });
    }
  } 

  clearSuccessMsg() {
    let tab = this.rootScopeService.activeCustTab;

    return (this.rootScopeService.isLiveCall && tab?.CS_SECURITY_LEVEL == Constants.securityLevels.SL4 && tab?.genesysAttributes?.CS_AUTH_CD == Constants.AuthCode.AIDV
      && ((tab?.clearIdentityData?.completedAllSteps || tab?.clearFraudIdentityData?.completedAllSteps)));
  }

  // CCR5-2629: Resolve the platform external ID for the selected role during an FSBA role change.
  extractPlatformId() {
    const activeTab = this.rootScopeService.activeCustTab;
    const idMappingArr = activeTab?.tabData?.tabData?.idMapping;
    return idMappingArr?.find(
      x => x.platformInternalId === activeTab?.roleObj?.platformInternalId
    )?.platformExternalId;
  }


  
  /**
   * CCR1-15016: fetch and cache the support-links disabled flag for the active client/domain
   * so isSupportLinksDisabled() has data to evaluate when navigating to a cached domain.
   * @author :Sultan Khan
   */
  getSupportLinksConfigForActiveClient(domainId: string): void {
    const clientId = this.rootScopeService?.activeCustTab?.clientId;
    if (!clientId || !domainId) {
      return;
    }

    const clientConfig = this.rootScopeService.supportLinksConfig.get(clientId);
    if (clientConfig?.hasOwnProperty(domainId)) {
      return;
    }

    const url = `${Global.domainUrl}${Global.SUPPORT_LINKS_CONFIG_API}`;
    const headers = this.rootScopeService.getCustAccHeaders(Constants.apiVersions, this.rootScopeService.activeCustTab.customerSessionId);

    this.http.get(url, { headers, params: { domainId } })
      .subscribe({
        next: (res: any) => {
          const latestConfig = this.rootScopeService.supportLinksConfig.get(clientId);
          this.rootScopeService.supportLinksConfig.set(clientId, { ...latestConfig, [domainId]: res?.data === true });
        },
        error: (error) => {
          this.logger.errorLogs("Error in fetching support links config: " + JSON.stringify(error), this.fileName);
        }
      });
  }




}